var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z",
    stroke: "#1F2A37",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7V9ZM16 8V9V8ZM11 21.5C11 22.0523 11.4477 22.5 12 22.5C12.5523 22.5 13 22.0523 13 21.5H11ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15V13ZM15 15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13V15ZM17 7H16V9H17V7ZM11 12V21.5H13V12H11ZM16 7C15.0855 7 14.299 6.99788 13.6722 7.08214C13.0167 7.17027 12.3883 7.36902 11.8787 7.87868L13.2929 9.29289C13.369 9.21677 13.505 9.12262 13.9387 9.06431C14.4012 9.00212 15.0289 9 16 9V7ZM13 12C13 11.0289 13.0021 10.4012 13.0643 9.9387C13.1226 9.50496 13.2168 9.36902 13.2929 9.29289L11.8787 7.87868C11.369 8.38834 11.1703 9.01669 11.0821 9.67221C10.9979 10.299 11 11.0855 11 12H13ZM10 15H15V13H10V15Z",
    fill: "#1F2A37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b113e492d2e394a7470adc1abf20d3d6.svg";
export { ForwardRef as ReactComponent };